namespace RioERP.Masters {
    export interface SmsTemplateVariablesForm {
        VariableCode: Serenity.StringEditor;
        VariableName: Serenity.StringEditor;
    }

    export class SmsTemplateVariablesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.SmsTemplateVariables';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SmsTemplateVariablesForm.init)  {
                SmsTemplateVariablesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(SmsTemplateVariablesForm, [
                    'VariableCode', w0,
                    'VariableName', w0
                ]);
            }
        }
    }
}
